const CATEGORY_FILTERS = [
  {
    id: 'meals',
    label: 'Meals',
    types: ['meals'],
    subtypes: [
      {
        id: 'protein-veggie-meals',
        parent: 'meals',
        label: 'Protein & veggie meals',
        types: ['meal_protein_and_veggie']
      },
      {
        id: 'protein-carb-meals',
        parent: 'meals',
        label: 'Protein & carb meals',
        types: ['meal_protein_and_starch']
      },
      {
        id: 'protein-veggie-carb-meals',
        parent: 'meals',
        label: 'Protein, veggie & carb meals',
        types: ['meal_protein_and_starch_veg']
      },
      {
        id: 'pasta-risotto',
        parent: 'meals',
        label: 'Pasta & risotto',
        types: ['meal_pasta_and_risotto']
      },
      {
        id: 'salads-bowls',
        parent: 'meals',
        label: 'Salads & bowls',
        types: ['meal_salad_and_bowls']
      },
      {
        id: 'soups-stews',
        parent: 'meals',
        label: 'Soups & stews',
        types: ['meal_soups_and_stews']
      },
      {
        id: 'tacos-burritos',
        parent: 'meals',
        label: 'Tacos & burritos',
        types: ['meal_tacos_and_burritos']
      },
      {
        id: 'sandwiches-pizza',
        parent: 'meals',
        label: 'Sandwiches & pizza',
        types: ['meal_sandwiches_and_pizza']
      },
      {
        id: 'kids',
        parent: 'meals',
        label: 'Kids',
        types: ['family_favorites']
      }
    ]
  },
  {
    id: 'breakfast',
    label: 'Breakfast',
    types: ['breakfast'],
    subtypes: [
      {
        id: 'power-bites',
        parent: 'breakfast',
        label: 'Power bites',
        types: ['power_bites']
      },
      {
        id: 'breakfast-sweets',
        parent: 'breakfast',
        label: 'Breakfast sweets',
        types: ['breakfast_sweets']
      },
      {
        id: 'parfaits-oats',
        parent: 'breakfast',
        label: 'Parfaits & oats',
        types: ['parfaits_and_oats']
      },
      {
        id: 'sandwiches-wraps',
        parent: 'breakfast',
        label: 'Sandwiches & wraps',
        types: ['breakfast_sandwiches_and_wraps']
      },
      {
        id: 'morning-plates',
        parent: 'breakfast',
        label: 'Morning plates',
        types: ['morning_plates']
      }
    ]
  },
  {
    id: 'bundles',
    label: 'Bundles',
    types: ['bundles'],
    subtypes: []
  },
  {
    id: 'sides',
    label: 'Sides',
    types: ['mix_and_match'],
    subtypes: [
      {
        id: 'veggies-salads',
        parent: 'sides',
        label: 'Veggies & salads',
        types: ['veggies_&_salads']
      },
      {
        id: 'grains-legumes-potatoes',
        parent: 'sides',
        label: 'Grains, legumes & potatoes',
        types: ['grains_&_starches']
      },
      {
        id: 'pasta-noodles-bread',
        parent: 'sides',
        label: 'Pasta, noodles & bread',
        types: ['pasta_&_bread']
      },
      {
        id: 'finger-foods-dips',
        parent: 'sides',
        label: 'Finger foods & dips',
        types: ['finger_foods']
      },
      { id: 'soups', parent: 'sides', label: 'Soups', types: ['side_soups'] }
    ]
  },
  {
    id: 'proteins-only',
    label: 'Proteins only',
    types: ['protein_only'],
    subtypes: []
  },
  {
    id: 'juices',
    label: 'Juices',
    types: ['drinks'],
    subtypes: []
  },
  {
    id: 'treats',
    label: 'Treats',
    types: ['treats'],
    subtypes: []
  },
  {
    id: 'snacks',
    label: 'Snacks',
    types: ['snacks'],
    subtypes: []
  },
  {
    id: 'wines',
    label: 'Wines',
    types: ['wine'],
    subtypes: [
      { id: 'red-wine', parent: 'wines', label: 'Red', types: ['red_wine'] },
      {
        id: 'white-wine',
        parent: 'wines',
        label: 'White',
        types: ['white_wine']
      },
      { id: 'rose-wine', parent: 'wines', label: 'Rosé', types: ['pink_wine'] },
      {
        id: 'themed-sets',
        parent: 'wines',
        label: 'Themed Sets',
        types: ['wine_bundle']
      }
    ]
  }
]

const PROTEIN_FILTERS = [
  {
    id: 'all-beef',
    label: 'Beef',
    types: ['all_beef'],
    subtypes: [
      {
        id: 'grass-fed-beef',
        parent: 'all-beef',
        label: 'Grass-Fed Beef',
        types: ['grass_fed_beef']
      }
    ]
  },
  {
    id: 'protein-lamb',
    label: 'Lamb',
    types: ['protein_lamb'],
    subtypes: []
  },
  {
    id: 'all-chicken',
    label: 'Chicken',
    types: ['all_chicken'],
    subtypes: [
      {
        id: 'organic-chicken',
        parent: 'all-chicken',
        label: 'Organic Chicken',
        types: ['organic_chicken']
      },
      {
        id: 'white-meat',
        parent: 'all-chicken',
        label: 'White meat',
        types: ['chicken_white_meat']
      },
      {
        id: 'dark-meat',
        parent: 'all-chicken',
        label: 'Dark meat',
        types: ['chicken_dark_meat']
      }
    ]
  },
  {
    id: 'protein-pork',
    label: 'Pork',
    types: ['protein_pork'],
    subtypes: []
  },
  {
    id: 'all-fish',
    label: 'Fish',
    types: ['all_fish'],
    subtypes: [
      {
        id: 'responsibly-farmed-fish',
        parent: 'all-fish',
        label: 'Responsibly Farmed Fish',
        types: ['responsibly_farmed_fish']
      }
    ]
  },
  {
    id: 'all-shellfish',
    label: 'Shellfish',
    types: ['all_shellfish'],
    subtypes: [
      {
        id: 'responsibly-farmed-shellfish',
        parent: 'all-shellfish',
        label: 'Responsibly Farmed Shellfish',
        types: ['responsibly_farmed_shellfish']
      }
    ]
  },
  {
    id: 'eggs-and-dairy',
    label: 'Eggs & Dairy',
    types: ['eggs_and_dairy'],
    subtypes: []
  },
  {
    id: 'all-plant-based',
    label: 'Plant-based',
    types: ['all_plant_based'],
    subtypes: [
      {
        id: 'tofu',
        parent: 'all-plant-based',
        label: 'Tofu',
        types: ['protein_tofu']
      },
      {
        id: 'grains-legumes-veggies',
        parent: 'all-plant-based',
        label: 'Grains, Legumes & Veggies',
        types: ['grains_legumes_veggies']
      }
    ]
  },
  {
    id: 'meat-alternatives',
    label: 'Meat Alternatives',
    types: ['meat_alternatives'],
    subtypes: []
  }
]
const DIET_FILTERS = [
  {
    id: 'vegetarian',
    label: 'Vegetarian',
    types: ['vegetarian'],
    subtypes: []
  },
  {
    id: 'vegan',
    label: 'Vegan',
    types: ['vegan'],
    subtypes: []
  },
  {
    id: 'pescatarian-diet',
    label: 'Pescatarian',
    types: ['pescatarian diet'],
    subtypes: []
  },
  {
    id: 'keto-diet',
    label: 'Keto Diet',
    types: ['keto diet'],
    subtypes: []
  },
  {
    id: 'glp-1-balance',
    label: 'GLP-1 Balance',
    types: ['glp_1'],
    subtypes: []
  },
  {
    id: 'mediterranean-diet',
    label: 'Mediterranean Diet',
    types: ['mediterranean diet'],
    subtypes: []
  }
]

const AVOID_FILTERS = [
  {
    id: 'added-sugars',
    label: 'Added Sugars',
    types: ['no added sugar'],
    subtypes: []
  },
  {
    id: 'dairy',
    label: 'Dairy',
    types: ['dairy free'],
    subtypes: []
  },
  {
    id: 'gluten',
    label: 'Gluten',
    types: ['gluten free'],
    subtypes: []
  },
  {
    id: 'soy',
    label: 'Soy',
    types: ['soy free'],
    subtypes: []
  },
  {
    id: 'nuts',
    label: 'Nuts',
    types: ['tree nut free'],
    subtypes: []
  },
  {
    id: 'peanuts',
    label: 'Peanuts',
    types: ['peanut free'],
    subtypes: []
  },
  {
    id: 'pork',
    label: 'Pork',
    types: ['pork free'],
    subtypes: []
  }
  /* {
    id: 'spicy-meals',
    label: 'Spicy Meals',
    types: ['spicy'],
    subtypes: [],
    isNegative: true
  } */
]

const CUISINE_FILTERS = [
  {
    id: 'asian',
    label: 'Asian',
    types: ['asian'],
    subtypes: [
      {
        id: 'indian',
        parent: 'asian',
        label: 'Indian',
        types: ['indian']
      },
      {
        id: 'korean',
        parent: 'asian',
        label: 'Korean',
        types: ['korean']
      },
      {
        id: 'thai',
        parent: 'asian',
        label: 'Thai',
        types: ['thai']
      },
      {
        id: 'japanese',
        parent: 'asian',
        label: 'Japanese',
        types: ['japanese']
      },
      {
        id: 'chinese',
        parent: 'asian',
        label: 'Chinese',
        types: ['chinese']
      },
      {
        id: 'other-asian-cuisines',
        parent: 'asian',
        label: 'Other Asian Cuisines',
        types: ['asian_others']
      }
    ]
  },
  {
    id: 'latin-american',
    label: 'Latin American',
    types: ['latin american'],
    subtypes: [
      {
        id: 'mexican',
        parent: 'latin-american',
        label: 'Mexican',
        types: ['mexican']
      },
      {
        id: 'other-latin-cuisines',
        parent: 'latin-american',
        label: 'Other Latin Cuisines',
        types: ['latin_american_others']
      }
    ]
  },
  {
    id: 'european',
    label: 'European',
    types: ['european'],
    subtypes: [
      {
        id: 'italian',
        parent: 'european',
        label: 'Italian',
        types: ['italian']
      },
      {
        id: 'french',
        parent: 'european',
        label: 'French',
        types: ['french']
      },
      {
        id: 'other-european-cuisines',
        parent: 'european',
        label: 'Other European Cuisines',
        types: ['european_others']
      }
    ]
  },
  {
    id: 'american',
    label: 'American',
    types: ['american'],
    subtypes: []
  },
  {
    id: 'mediterranean',
    label: 'Mediterranean',
    types: ['mediterranean'],
    subtypes: []
  },
  {
    id: 'middle-eastern',
    label: 'Middle Eastern',
    types: ['middle eastern'],
    subtypes: []
  },
  {
    id: 'african',
    label: 'African',
    types: ['african'],
    subtypes: []
  },
  {
    id: 'caribbean',
    label: 'Caribbean',
    types: ['caribbean'],
    subtypes: []
  }
]

export const NEW_FILTERS = {
  categories: CATEGORY_FILTERS,
  proteins: PROTEIN_FILTERS,
  cuisines: CUISINE_FILTERS,
  preferences: [],
  diets: DIET_FILTERS,
  avoids: AVOID_FILTERS
}
